<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="tutorial-view">
    <h2 class="tuto-title" v-html="tutorialView.title" />
    <div v-cms="tutorialView.htmldefinition" class="tuto-def" />
  </div>
</template>

<script>

import { vCmsHtml as cms } from '@/services/graphql'

export default {
  components: {  },
  directives: { cms },
  props: {
    tutorialsData: {
      type: Array
    },
    selectedTuto: {
      type: Object,
    },
  },
  computed: {
    tutorialView() {
      let fol = this.tutorialsData.find(el => el.name === this.selectedTuto.folder)
      return fol.options.find(x => x.name === this.selectedTuto.option)
    },
  },
  asyncComputed: {},
}
</script>

<style lang="stylus" scoped>
.tutorial-view
  position: relative
  display: flex
  flex-direction: column
  width: inherit
  background-color: #fff
  padding: vw(20px) vw(25px)
  padding-right: 180px
  
  .mobile &
    padding-right: vw(25px)
  
  .tuto-title
    m-font-size(26, 30)
    color: black
    font-weight: 600
    color: $base-font-color
    margin-block-start: 0
    margin-block-end: 0
    
    .mobile &
      margin-bottom: vw(20px)

  .tuto-def
    m-font-size(16, 24)
    color: $grey-dark

    >>> .anchor
      position: relative
      top: vw(-80px)
    
    >>> .border-table
      border:  1px solid black
      border-collapse: collapse
      
      td
        border:  1px solid black
        padding: vw(5px)
      
    >>> .code-box
      padding: vw(10px)
      border: 1px solid $grey
      background-color: $light-grey
      border-radius: 4px
    
    >>> .index
      position: sticky
      margin-left: 'calc(100% + %s)' % vw(20px)
      top: "calc(%s + %s + %s)" % ($header-height $subheader-height vw(10px))
      width: 158px
      height: 0
      display: flex
      flex-direction: column
      gap: vw(10px)
      
      .mobile &
        position: inherit
        height: auto
        margin-left: 0
        width: 100%
      
      .desc-wrap
        display: flex
        flex-direction: column
        margin-bottom: vw(15px)
      
        .title
          color: black
          m-font-size(18, 26)
          font-weight: 600
        
        .desc
          color: black
          m-font-size(14, 22)
          font-weight: 300
      
      .link
        color: $corporate_color
        m-font-size(14, 22)
        font-weight: 400
        
        &::before 
          content: "- "
          color: $corporate_color
          
        &.link-2
          margin-left: vw(15px)
          
        &.link-3
          margin-left: vw(30px)
    
    >>> .iframe-wrap
      margin-top: vw(25px)
      position: relative;
      height: 0;
      padding-bottom: 56.25%;

    >>> iframe
      position: absolute
      top: 0
      left: 0
      border: 0
      width: 100%
      height: 100%
      

    >>> a
      color: $corporate_color
      text-decoration: none

      &:hover
        color: $corporate_color
        text-decoration: underline
        cursor: pointer

    >>> li
      margin-left: vw(20px)
      padding: 0
      list-style-type: disc

</style>
